import React from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { SubscriptDecoration } from './../../ricos-schema/next-schema/generated/ricos_document.js';
import type { NodeViewDecorator } from './../../ricos-types/index.js';

const decorator = (element: JSX.Element, subscriptDecoration: SubscriptDecoration) => {
  const { subscriptData } = subscriptDecoration;
  const isSubscript = typeof subscriptData === 'undefined' || subscriptData;
  return isSubscript ? <sub key={`subscript-${element?.key}`}>{element}</sub> : element;
};

const SubscriptDecorator: NodeViewDecorator<JSX.Element> = {
  rule: (node: Node) =>
    !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.SUBSCRIPT),
  decorate: ({ element, node }) => {
    const subscriptDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.SUBSCRIPT
    ) as SubscriptDecoration;
    return decorator(element as JSX.Element, subscriptDecoration);
  },
};

export default SubscriptDecorator;
